import { useEffect, Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Footer from "./components/Footer";
import { initGA, logPageView } from "./components/Analytics";
import { initializeDatadog } from "./monitoring/dataDog";

// Lazy load components
const Home = lazy(() => import("./Home"));
const Links = lazy(() => import("./Links"));
const Resources = lazy(() => import("./resources"));
const MOS = lazy(() => import("./mos"));
const BestWarrior = lazy(() => import("./BestWarrior"));
const NorwegianRuckMarch = lazy(() => import("./NorwegianRuckMarch"));
const GAFPB = lazy(() => import("./GAFPB"));
const NCOResources = lazy(() => import("./NCOResources"));
const WeaponsQual = lazy(() => import("./WeaponsQual"));
const LandNavigation = lazy(() => import("./LandNavigation"));
const Communications = lazy(() => import("./Communications"));
const NotFound = lazy(() => import("./NotFound"));

function Analytics() {
  const location = useLocation();
  useEffect(() => {
    logPageView();
  }, [location]);
}

function App() {
  useEffect(() => {
    initializeDatadog();
    // initGA now handles error tracking and returns a cleanup function
    const cleanup = initGA();

    return cleanup;
  }, []);

  return (
    <>
      <BrowserRouter>
        <Analytics />
        <Suspense fallback={<div className="text-center p-5">Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/links" element={<Links />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/mos" element={<MOS />} />
            <Route path="/best-warrior" element={<BestWarrior />} />
            <Route
              path="/norwegian-ruck-march"
              element={<NorwegianRuckMarch />}
            />
            <Route path="/gafpb" element={<GAFPB />} />
            <Route path="/nco-resources" element={<NCOResources />} />
            <Route path="/weapons-qual" element={<WeaponsQual />} />
            <Route path="/land-navigation" element={<LandNavigation />} />
            <Route path="/communications" element={<Communications />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Footer />
    </>
  );
}

export default App;
